import { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Search, Phone, Mail, Menu as MenuIcon, Lock } from "lucide-react";

const MENU = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Important Notices", to: "/important-notices" },
  { label: "Latest Update", to: "/latest-update" },
  { label: "Act and Rules", to: "/act-and-rules" },
  { label: "Budgets/Allotments", to: "/budgets" },
  { label: "Recruitments", to: "/recruitments" },
  { label: "Syllabus", to: "/syllabus" },
  { label: "Objection Portal", to: "/objection-portal" },
  { label: "Admit Card/Call Letter", to: "/admit-card" },
  { label: "Score Card", to: "/score-card" },
  { label: "Result", to: "/result" },
  { label: "Tender", to: "/tender" },
];

export default function PublicLayout() {
  const [lang, setLang] = useState("English");
  const [query, setQuery] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="site-root">
      {/* Top utility bar */}
      <div className="topbar" data-testid="top-bar">
        <div className="topbar-inner">
          <div className="topbar-links">
            <a href="#" data-testid="link-sitemap">Sitemap</a>
            <a href="#main-content" data-testid="link-skip">Skip to Main Content</a>
            <a href="#" data-testid="link-screen-reader">Screen Reader Access</a>
            <button className={`lang-btn ${lang === "English" ? "active" : ""}`} onClick={() => setLang("English")} data-testid="lang-english">English</button>
            <button className={`lang-btn ${lang === "Hindi" ? "active" : ""}`} onClick={() => setLang("Hindi")} data-testid="lang-hindi">Hindi</button>
            <span className="font-ctrls">
              <button data-testid="font-decrease">-A</button>
              <button data-testid="font-normal">A</button>
              <button data-testid="font-increase">+A</button>
            </span>
            <span className="theme-ctrls">
              <button className="theme-dot dark" data-testid="theme-dark" aria-label="Dark theme">A</button>
              <button className="theme-dot light" data-testid="theme-light" aria-label="Light theme">A</button>
            </span>
            <button className="admin-login-btn" onClick={() => navigate("/admin/login")} data-testid="topbar-admin-login">
              <Lock size={12} /> Admin Login
            </button>
          </div>
          <form
            className="topbar-search"
            onSubmit={(e) => { e.preventDefault(); }}
            data-testid="search-form"
          >
            <input
              placeholder="Search by keyword or phrase."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid="search-input"
            />
            <button type="submit" data-testid="search-submit"><Search size={16} /></button>
          </form>
        </div>
      </div>

      {/* Blue banner */}
      <header className="banner" id="main-content">
        <div className="banner-inner">
          <div className="banner-left">
            <img
              className="bihar-logo"
              src="https://customer-assets-v7afamib.emergentagent.net/job_match-admin-portal-2/artifacts/vgidpwkl_btsbih%20logo.jpg"
              alt="Bihar Sarkar"
            />
          </div>
          <div className="banner-title">
            <h1>Bihar Technical Service Commission</h1>
            <p>19, Harding Road, Patna – 800001</p>
          </div>
          <div className="banner-right">
            <img
              className="digital-logo"
              src="https://customer-assets-v7afamib.emergentagent.net/job_match-admin-portal-2/artifacts/ahxk5g0u_btsbih2.jpg"
              alt="Digital India | Satyameva Jayate"
            />
          </div>
        </div>
      </header>

      {/* Body: sidebar + content */}
      <div className="body-wrap">
        <aside className="sidebar" data-testid="sidebar-menu">
          <div className="sidebar-head">
            <span>Menu</span>
            <button className="mobile-toggle" onClick={() => setMobileOpen((v) => !v)} data-testid="mobile-menu-toggle">
              <MenuIcon size={18} />
            </button>
          </div>
          <nav className={mobileOpen ? "open" : ""}>
            {MENU.map((m) => (
              <NavLink
                key={m.to}
                to={m.to}
                end={m.to === "/"}
                className={({ isActive }) => `menu-item ${isActive ? "active" : ""}`}
                onClick={() => setMobileOpen(false)}
                data-testid={`menu-${m.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
              >
                {m.label}
              </NavLink>
            ))}
          </nav>

          <div className="helpdesk" data-testid="helpdesk">
            <h3>Helpdesk</h3>
            <p>(10:00 AM TO 06:00 PM)</p>
            <p className="hd-line"><Phone size={13} /> Toll Free No: 18003456221</p>
            <p className="hd-line"><Mail size={13} /> Email ID: btssc-bih@gov.in</p>
          </div>
        </aside>

        <main className="content" data-testid="page-content">
          <Outlet />
        </main>
      </div>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="footer-links">
          <a href="#">Archive Notices</a> | <a href="#">Website Policies</a> | <a href="#">Disclaimer</a>
        </div>
        <div className="footer-meta">
          <div className="valid-badges">
            <span className="badge">W3C CSS</span>
            <span className="badge">W3C HTML5</span>
          </div>
          <div>Total Visitors: <b>32041367</b></div>
          <div>Last Updated <b>27-08-2026 04:33:38</b></div>
        </div>
        <div className="footer-credit">
          Website is designed, developed and maintained by Perfect Ergonomics Pvt. Ltd. Website hosted on SDC Server.
          <button className="admin-link" onClick={() => navigate("/admin/login")} data-testid="footer-admin-link">Admin</button>
        </div>
      </footer>
    </div>
  );
}
